<template>
    <div>
        <div class="modal-body">
            <div class="row gutters">
                <div class="col-6">
                    <div class="form-group">
                        <label for="signer">{{ t('DOCUMENTS.SIGNER_DOC.SIGNER') }}</label>
                        <input type="text" class="form-control" id="signer" v-model="signer.name" disabled>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="taxpayer">{{ t('DOCUMENTS.SIGNER_DOC.TAXPAYER') }}</label>
                        <input type="text" class="form-control" id="taxpayer" v-model="signer.documentation" disabled>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="email">{{ t('DOCUMENTS.SIGNER_DOC.MAIL') }}</label>
                        <input type="text" class="form-control" id="email" v-model="signer.email" disabled>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="phone">{{ t('DOCUMENTS.SIGNER_DOC.PHONE') }}</label>
                        <input type="text" class="form-control" id="phone" v-model="signer.phone_number" disabled>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <div class="dropdown-divider"></div>
                    <div class="text-center font-weight-bolder" style="color: #0e5e4e">
                        <label class="font-14">
                            <i class="icon-settings1"/> Configurações de assinatura:
                        </label>
                    </div>
                </div>
                <div v-if="supportsPresentialSignature" class="flex-grow-1 align-self-center pl-1">
                    <div class="form-group" style="min-width: 87px">
                        <label>Modo de assinatura</label>
                        <Select2 v-model="signer.signature_mode"
                                 placeholder="Selecione"
                                 :options="signatureModeOptions"
                                 @select="changeSignatureMode()"
                                 :settings="{width:'80%'}"></Select2>
                    </div>
                </div>
                <div v-if="supportsPresentialSignature && signer.signature_mode === 'presential'" class="col-6">
                    <div class="form-group">
                        <label for="signature_host_name">Nome do anfitrião</label>
                        <input type="text" class="form-control" id="signature_host_name" v-model="signer.signature_host.name">
                    </div>
                </div>
                <div v-if="supportsPresentialSignature && signer.signature_mode === 'presential'" class="col-6">
                    <div class="form-group">
                        <label for="signature_host_email">E-mail do anfitrião</label>
                        <input type="email" class="form-control" id="signature_host_email" v-model="signer.signature_host.email">
                    </div>
                </div>
                <div class="flex-grow-1 align-self-center pl-1">
                    <div class="form-group" style="min-width: 87px">
                        <label>{{ t('DOCUMENTS.AUTHS') }}</label>
                        <Select2 v-model="signer.auths" placeholder="Selecione" v-if="['seller', 'witness'].includes(signer.sign_as)"
                                 :options="authOptionsForSigner"
                                 :disabled="!['seller', 'witness'].includes(signer.sign_as)"
                                 @select="changeAuth()"
                                 :settings="{width:'80%'}"></Select2>
                        <Select2 v-model="signer.auths" placeholder="Selecione" v-else
                                 :options="authOptionsForSigner"
                                 @select="changeAuth()"
                                 :settings="{width:'80%'}"></Select2>
                    </div>
                </div>
                <div class="col-6 align-self-center">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input"
                               id="selfie_enabled"
                               v-model="signer.selfie_enabled" :disabled="signer.auths === 'icp_brasil'">
                        <label class="custom-control-label"
                               for="selfie_enabled">{{
                                t('DOCUMENTS.SELFIE_ENABLED')
                            }}
                        </label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input"
                               id="official_document_enabled"
                               v-model="signer.official_document_enabled" :disabled="signer.auths === 'icp_brasil'">
                        <label class="custom-control-label"
                               for="official_document_enabled">{{
                                t('DOCUMENTS.OFFICIAL_DOCUMENT_ENABLED')
                            }}
                        </label>
                    </div>
                </div>

                <div class="col-6 align">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input"
                               id="handwritten_enabled"
                               v-model="signer.handwritten_enabled" :disabled="signer.auths === 'icp_brasil'">
                        <label class="custom-control-label"
                               for="handwritten_enabled">{{
                                t('DOCUMENTS.HANDWIRITTEN_ENABLED')
                            }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" @click="saveSigner">Salvar</button>
        </div>
    </div>
</template>

<script>
import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';
import {mapActions, mapState} from 'vuex';
import Select2 from 'vue3-select2-component';

export default {
    name: "editSignerComponent",
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
    components:{
        Select2
    },
    mounted() {
        if (localStorage.getItem('company_id') && ['4d45d80c-829c-4013-80a6-b0d036012b59','ca8ecad3-9e79-4bce-965c-1d7ed59361f0'].includes(localStorage.getItem('company_id'))){
            this.optionZap = [{id:'whatsapp', text: 'Whatsapp'}];
        }

        if (!this.supportsPresentialSignature) {
            this.signer.signature_mode = 'remote';
            this.signer.signature_host = null;
        }
    },
    computed: {
        ...mapState({signer: (state) => state.document.showSigner}),
        supportsPresentialSignature() {
            return !!this.signer?.envelope_id;
        },
        authOptionsForSigner() {
            const baseOptions = [
                {id: 'email', text: 'E-mail'},
                {id: 'sms', text: 'SMS'},
                ...this.optionZap,
            ];

            if (this.signer.signature_mode === 'presential') {
                return baseOptions;
            }

            if (['seller', 'witness'].includes(this.signer.sign_as)) {
                return [...baseOptions, {id: 'icp_brasil', text: 'ICP-Brasil'}];
            }

            return baseOptions;
        }
    },
    data(){
        return{
            optionZap:[],
            signatureModeOptions:[
                {id: 'remote', text: 'Remota'},
                {id: 'presential', text: 'Presencial'},
            ],
        }
    },
    methods:{
        ...mapActions({
            alterConfigSignerDoc:'alterConfigSignerDoc'
        }),
        changeAuth()
        {
            if (this.signer.auths === 'icp_brasil'){
                this.signer.selfie_enabled = false;
                this.signer.handwritten_enabled = false;
                this.signer.official_document_enabled = false;
            }
        },
        changeSignatureMode()
        {
            if (!this.supportsPresentialSignature) {
                this.signer.signature_mode = 'remote';
                this.signer.signature_host = null;
                return;
            }

            if (this.signer.signature_mode !== 'presential') {
                this.signer.signature_host = null;
                return;
            }

            this.signer.signature_host = this.signer.signature_host || {name: '', email: ''};

            if (this.signer.auths === 'icp_brasil') {
                this.signer.auths = 'email';
            }
        },
        saveSigner()
        {
            if(!this.signer.id){
                this.toast.error('Necessario selecionar um signátario');
                return;
            }

            if (!this.signer.signature_mode) {
                this.signer.signature_mode = 'remote';
            }

            if (!this.supportsPresentialSignature) {
                this.signer.signature_mode = 'remote';
                this.signer.signature_host = null;
            }

            if (this.signer.signature_mode === 'presential') {
                if (!this.signer.signature_host?.name || !this.signer.signature_host?.email) {
                    this.toast.error('Informe nome e e-mail do anfitrião para assinatura presencial.');
                    return;
                }
            }

            this.alterConfigSignerDoc({data:this.signer});
        },
    }
}
</script>

<style scoped>

</style>
